import React, { useEffect, useState } from 'react';
import { graphql, useStaticQuery } from "gatsby";
import * as b from "../bootstrap.module.css";
import Icon from "../icon.tsx";
import useMedia from '../../hooks/useMedia';
import AccountPrimaryContents from './content-column/account-primary-contents';
import PersonalAccountContents from './content-column/personal-account-contents';
import ChildAccountContents from './content-column/child-account-contents';
import SavingAccountContents from './content-column/savings-account-contents';
import ForeingCurrencyAccountContents from './content-column/foreign-currency-account-contents';
import SavingAccountProducts from './product-column/saving-account-products';
import PersonalAccountProducts from './product-column/personal-account-products';

const AccountNavigation = ({ activeNavigation, changeNavigation }) => {
  const { categories } = useStaticQuery(graphql`
    query AccountTopNavigation {
      categories: allMysqlTerms(filter: {cluster: {in: ["accounts_1", "accounts_2", "accounts_4", "accounts_5"]}}) {
        nodes {
          term
          term_normalized
          path
          cluster
          menu_icon
        }
      }
    }
  `);

  const [activeTab, setActiveTab] = useState('');
  const isMobileResolution = useMedia(['(max-width: 992px)'], [true], false);

  const changeTab = (cluster) => setActiveTab(activeTab !== cluster ? cluster :  '');
  const previousStep = () => {
    if (activeTab) {
      setActiveTab('');
    } else if (activeNavigation) {
      changeNavigation('');
    }
  };

  useEffect(() => {
    if (activeNavigation !== 'accounts') {
      setActiveTab('');
    }
  }, [activeNavigation]);

  if (!categories.nodes.length) {
    return null;
  }

  return (
    <div className={['top-navigation-tabs', 'active', activeNavigation !== 'accounts' ? b.dNone : ''].join(' ')}>
      <div className="top-navigation-links">
        {isMobileResolution ? (<>
          <button onClick={previousStep} className="top-navigation-prev-step">
            <span className={[b.container, b.dFlex, b.alignItemsCenter].join(' ')}>
              <span className={b.pr1}>
                <Icon icon="Angle-left" size={24} color="#2B2B2B" />
              </span>

              <span>
                Cofnij do
                <strong>{activeTab ? 'kont bankowych' : 'menu głównego'}</strong>
              </span>
            </span>
          </button>

          {!activeTab && <strong className="top-navigation-title">Konta</strong>}

          <div className={b.pt1}>
            {categories.nodes.filter((category) => !activeTab || activeTab === category.cluster).map((category, i) => (
              <button 
                key={i} 
                onClick={() => changeTab(category.cluster)}
                className={["top-navigation-link", "top-navigation-link-arrow", activeTab === category.cluster ? 'active' : ''].join(' ')}
              >
                <span className="top-navigation-link-icon">
                  <Icon icon={category.menu_icon} size={34} />
                </span>

                {category.term}
              </button>
            ))}
          </div>
        </>) : (<>
          <strong className="top-navigation-title">Konta</strong>
        
          <div className={[b.mt2, b.pt1].join(' ')}>
            {categories.nodes.map((category, i) => (
              <button 
                key={i} 
                onClick={() => changeTab(category.cluster)}
                className={["top-navigation-link", "top-navigation-link-arrow", activeTab === category.cluster ? 'active' : ''].join(' ')}
              >
                <span className="top-navigation-link-icon">
                  <Icon icon={category.menu_icon} size={34} />
                </span>

                {category.term}
              </button>
            ))}
          </div>
        </>)}
      </div>
      
      <div className="top-navigation-products">
        <div className={activeTab !== '' ? b.dNone : ''}><AccountPrimaryContents /></div>
        <div className={activeTab !== 'accounts_1' ? b.dNone : ''}><PersonalAccountProducts /></div>
        <div className={activeTab !== 'accounts_2' ? b.dNone : ''}><SavingAccountProducts /></div>
        <div className={activeTab !== 'accounts_4' ? b.dNone : ''}><ChildAccountContents /></div>
        <div className={activeTab !== 'accounts_5' ? b.dNone : ''}><ForeingCurrencyAccountContents /></div>
      </div>
      
      <div className="top-navigation-contents">
        <div className={activeTab !== 'accounts_1' ? b.dNone : ''}><PersonalAccountContents /></div>
        <div className={activeTab !== 'accounts_2' ? b.dNone : ''}><SavingAccountContents /></div>
      </div>
    </div>
  );
};

export default AccountNavigation;